import merge from 'deepmerge';

// helper of merge
export function overwriteMerge(
  target: unknown[],
  source: unknown[]
  //   options?: merge.Options | undefined
): unknown[] {
  return source;
}

// helper of merge
export function combineMerge(key: string) {
  return (
    target: { key: string }[],
    source: { key: string }[]
    // options?: merge.Options | undefined
  ) => {
    const result = merge([], target);
    source.forEach(item => {
      const targetItemIndex = result.findIndex(d => d[key] === item[key]);
      if (targetItemIndex > -1) {
        result[targetItemIndex] = merge(result[targetItemIndex], item);
      } else {
        result.push(item);
      }
    });
    return result;
  };
}

export function shuffleArray<T>(arr: Array<T>): Array<T> {
  for (let j, x, i = arr.length; i; ) {
    j = Math.floor(Math.random() * i);
    x = arr[--i];
    arr[i] = arr[j];
    arr[j] = x;
  }
  return arr;
}
